class CustomAccordion extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const accordionItems = this.querySelectorAll('.accordion-item');
        const handleAccordionClick = (event) => {
            const accordionContent = event.currentTarget.nextElementSibling;
            event.currentTarget.parentNode.classList.toggle('open');
            const contentHeight = accordionContent.scrollHeight;
            if (accordionContent) {
                accordionContent.style.maxHeight ? accordionContent.style.maxHeight = null : accordionContent.style.maxHeight = `${contentHeight + 15}px`;
            }
        };

        if (accordionItems) {
            accordionItems.forEach((item) => {
                const accordionHeader = item.querySelector('.accordion-header');
                accordionHeader.addEventListener('click', handleAccordionClick);
            });
        }
    }

}

customElements.define('custom-accordion', CustomAccordion);